const identityPolicyEn = {
  authenticationPolicy: {
    loginEmail: {
      card: {
        edit: 'Edit',
        title: 'Personal Email Login Restriction'
      },
      description: 'Configure whether personal email addresses can be used for login, per account type',
      editDialog: {
        cancelButton: 'Cancel',
        error: 'An error occurred while saving changes. Please try again',
        saveButton: 'Save',
        title: 'Personal Email Login Restriction'
      },
      loadError: 'Could not load',
      mode: {
        alwaysAllowed: {
          label: 'Not Restricted'
        },
        disallowed: {
          label: 'Always Restricted'
        },
        untilWorkEmailSet: {
          label: 'Restricted once employee email is set'
        }
      },
      retry: 'Retry',
      target: {
        individual: 'Individual',
        operator: 'Staff'
      },
      title: 'Personal Email Login',
      toast: {
        updateSuccess: 'Settings updated'
      }
    },
    loginMethod: {
      card: {
        edit: 'Edit',
        title: 'SSO Login Enforcement'
      },
      description: 'Require SSO login, per account type',
      editDialog: {
        cancelButton: 'Cancel',
        description: 'Set an enforcement date to allow a migration period',
        saveButton: 'Save',
        title: 'SSO Login Enforcement'
      },
      enforce: {
        datePlaceholder: 'Select a date',
        now: 'Enforced now',
        off: 'Optional',
        scheduled: 'Enforced from a specific date'
      },
      loadError: 'Could not load',
      provider: {
        label: 'SSO provider',
        loadError: 'Could not load SSO settings',
        notConfigured: 'Not configured',
        notConfiguredHint: 'Configure the connection used for login under “SSO”',
        retry: 'Retry'
      },
      retry: 'Retry',
      summary: {
        enforceFromFuture: {
          hint: 'Password login is available until then',
          value: 'Enforced from {{dateTime}}'
        },
        enforcedNow: {
          value: 'Enforced'
        },
        notRequired: {
          value: 'Optional'
        }
      },
      target: {
        individual: 'Individual',
        operator: 'Staff'
      },
      title: 'SSO Login',
      toast: {
        updateSuccess: 'Settings updated'
      }
    },
    mfa: {
      card: {
        edit: 'Edit',
        notRequired: 'Optional',
        required: 'Required',
        title: 'MFA Enforcement'
      },
      deleteDialog: {
        continueButton: 'Continue',
        description: 'Affected accounts will be able to sign in without an additional identity check',
        discardChangesButton: 'Discard changes',
        title: 'Remove the MFA Requirement?'
      },
      description: 'Adds one more identity check at sign-in',
      editDialog: {
        cancelButton: 'Cancel',
        error: 'An error occurred while saving changes. Please try again',
        saveButton: 'Save',
        title: 'MFA Enforcement'
      },
      loadError: 'Could not load',
      mfaMethod: {
        email: 'Email'
      },
      retry: 'Retry',
      title: 'MFA',
      userType: {
        individual: 'Individual',
        operator: 'Staff'
      }
    }
  },
  comingSoon: 'This setting is not available yet.',
  comingSoonBadge: 'Coming soon',
  passwordPolicy: {
    complexity: {
      lowercase: 'Lowercase letters',
      none: 'Not required',
      number: 'Numbers',
      symbol: 'Symbols',
      uppercase: 'Uppercase letters'
    },
    description: 'Controls password strength for DRESS CODE native sign-in with reference to NIST SP 800-63B-4.',
    edit: {
      cancelButton: 'Cancel',
      complexity: {
        description: 'NIST recommends length over character-type rules. Turn these on only when your own policy requires them.',
        title: 'Character type complexity'
      },
      description: 'These settings apply to DRESS CODE native sign-in only.',
      discardConfirm: 'Discard',
      discardDescription: 'You have unsaved changes. Leaving this page discards them.',
      discardTitle: 'Discard changes?',
      enforceFrom: {
        datePlaceholder: 'Select date',
        description: 'Choose whether to apply the policy immediately or schedule it for a future date and time.',
        immediateDescription: 'Make the policy effective as soon as it is saved.',
        immediateTitle: 'Apply immediately',
        requiredHint: 'Select an effective date and time.',
        scheduledDescription: 'Choose a future date and time for the policy to take effect.',
        scheduledTitle: 'Schedule',
        timePlaceholder: '--:--',
        title: 'Effective date and time'
      },
      leakedCheck: {
        description: 'Rejects passwords found in known breach lists. Recommended by NIST.',
        title: 'Breach list check'
      },
      minLength: {
        description: 'DRESS CODE recommends at least {{minLength}} characters.',
        hint: 'Enter a value between {{min}} and {{max}} characters.',
        title: 'Minimum length'
      },
      notConfiguredNotice: 'This organization has no custom policy yet, so the DRESS CODE standard settings are in effect. Saving makes them explicit.',
      notConfiguredTitle: 'No custom organization policy is configured',
      saveButton: 'Save',
      title: 'Edit password policy'
    },
    editButton: 'Edit',
    history: {
      button: 'History',
      close: 'Close history',
      collapse: 'Exit full screen',
      columns: {
        complexity: 'Character complexity',
        createdAt: 'Created',
        enforceFrom: 'Effective from',
        leakedCheck: 'Breach list check',
        minLength: 'Minimum length',
        status: 'Status'
      },
      complexity: {
        lowercase: 'Lowercase',
        none: 'None',
        number: 'Number',
        symbol: 'Symbol',
        uppercase: 'Uppercase'
      },
      description: 'Review the current, scheduled, and previous password policy versions.',
      empty: 'No password policy history.',
      expand: 'View full screen',
      leakedCheckOff: 'OFF',
      leakedCheckOn: 'ON',
      loadError: 'Failed to load password policy history.',
      minLengthValue: '{{value}} characters',
      status: {
        active: 'Active',
        scheduled: 'Scheduled',
        superseded: 'Inactive'
      },
      title: 'Password policy history'
    },
    loadError: 'Failed to load the password policy.',
    recommended: {
      applyButton: 'Apply recommended values',
      confirmDescription: 'DRESS CODE recommends {{summary}}. You can still save a weaker policy.',
      confirmTitle: 'Save a policy below the recommended level?',
      summary: {
        allComplexity: 'all four character types',
        leakedCheck: 'breached password check enabled',
        minLength: '{{minLength}}+ characters',
        partialComplexity: 'character types ({{types}})',
        separator: ', '
      },
      warning: 'This policy is below the DRESS CODE recommendation ({{summary}}).'
    },
    retry: 'Retry',
    rows: {
      complexity: 'Character type complexity',
      leakedCheck: 'Breach list check',
      leakedCheckHint: 'Rejects known breached or weak passwords.',
      leakedCheckOff: 'OFF',
      leakedCheckOn: 'ON',
      minLength: 'Minimum length',
      minLengthValue: '{{value}} characters'
    },
    standardBadge: 'References NIST SP 800-63B-4',
    title: 'Password policy',
    toast: {
      updateSuccess: 'Password policy updated'
    },
    versions: {
      currentTitle: 'Currently active policy',
      defaultBadge: 'Standard settings',
      enforceFromCurrent: 'Effective since {{date}}',
      enforceFromScheduled: 'Effective from {{date}}',
      enforceFromUnavailable: 'Effective date unavailable',
      enforceImmediate: 'Applied immediately',
      scheduledTitle: 'Scheduled policy',
      updatedAt: 'Updated: {{date}}'
    }
  }
};
export default identityPolicyEn;